/**
 * Account page module
 *
 * @module views/pages/requests/index
 */
define('views/pages/requests/index',['require','jquery','underscore','views/base/page','./navbar','./table','text!templates/pages/requests/index.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        PageView = require('views/base/page'),
        NavbarView = require('./navbar'),
        TableView = require('./table'),
        template = require('text!templates/pages/requests/index.ejs');

    var RequestsPageView = PageView.extend({
        id: 'page-requests',
        autoRender: true,
        template: template,
        windowResize: true,
        listen: {
            'change:loading model': 'render'
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('navbar', new NavbarView({ model: this.model, container: this.$el }));
            this.subview('table', new TableView({ collection: this.model.items, model: this.model, container: this.$el }));
        }
    });

    return RequestsPageView;
});

